module.exports = __webpack_public_path__ + "static/media/milk-email-header.0bd6e0b4.png";